export const STRIPE_DASHBOARD = "https://dashboard.stripe.com";

// Stripe Connect Publishable Key
// Note: Replace with your actual publishable key from Stripe Dashboard
export const STRIPE_PUBLISHABLE_KEY = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || "";
